import type { Time } from '@internationalized/date'
import * as React from 'react'
import { cn } from '../../utils/cn'
import { DateTimePickerContext } from './date-time-picker-context'

export function DateTimePickerRoot({
  children,
  className,
  defaultValue = new Date(),
  value: valueProp,
  onValueChange,
}: DateTimePickerRoot.Props) {
  const [value, setValue] = React.useState(defaultValue)

  React.useEffect(() => {
    setValue(valueProp ?? defaultValue)
  }, [valueProp])

  function setDateValue(dateValue: Date) {
    const newValue = new Date(value)
    newValue.setFullYear(dateValue.getFullYear(), dateValue.getMonth(), dateValue.getDate())
    setValue(newValue)
    onValueChange?.(newValue)
  }

  function setTimeValue(timeValue: Time) {
    const newValue = new Date(value)
    newValue.setHours(timeValue.hour, timeValue.minute, timeValue.second)
    setValue(newValue)
    onValueChange?.(newValue)
  }

  return (
    <DateTimePickerContext.Provider value={{ value, setDateValue, setTimeValue }}>
      <div className={cn('flex flex-col', className)}>{children}</div>
    </DateTimePickerContext.Provider>
  )
}

export namespace DateTimePickerRoot {
  export interface Props {
    children?: React.ReactNode
    className?: string
    defaultValue?: Date
    value?: Date
    onValueChange?: (date: Date) => void
  }
}
